module.exports = __webpack_public_path__ + "static/img/podkladovy_obrazek kopie.15c8646.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/podkladovy_obrazek kopie.jpg
// module id = xnJI
// module chunks = 1